import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import { ComponentProps, FC } from 'react';
import { Box, Button, ChipType, Typography } from '../../..';
import { FilterChip } from './FilterChips';

type AllChipsPopoverProps = {
  onClearAll: () => void;
  chips: ChipType[];
  variant?: 'primary' | 'secondary';
} & ComponentProps<typeof Popover>;

export const AllChipsPopover: FC<AllChipsPopoverProps> = ({
  onClearAll,
  chips,
  variant = 'primary',
  ...popOverProps
}) => {
  return (
    <Popover {...popOverProps}>
      <Box
        sx={{
          padding: '8px',
          maxWidth: '400px',
          display: 'grid',
          gap: '8px',
          gridTemplateRows: 'auto auto'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Typography>Filters:</Typography>
          <Button disableRipple variant="text" size="small" onClick={onClearAll}>
            clear all filters
          </Button>
        </Box>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            maxHeight: '30vh'
          }}
        >
          {chips.map(chip => (
            <FilterChip
              key={chip.key}
              label={chip.value}
              onDelete={chip.onDelete}
              size="small"
              color={variant === 'primary' ? 'primary' : undefined}
            />
          ))}
        </Box>
      </Box>
    </Popover>
  );
};
